<div
  class="text-primary-10 flex h-9 w-full items-center justify-center text-center"
  [ngClass]="environmentType + '-env-bg'"
  *ngIf="environmentType && environmentType !== 'prod'">
  <mat-icon class="mx-2" aria-label="Env icon warning">warning</mat-icon>
  {{ 'environment.type' | translate: { value: environmentType.toUpperCase() } }}
</div>
<div class="fixed flex w-full">
  <mat-toolbar
    [@slideInOut]="menuState"
    [ngClass]="{ 'hidden pr-10 lg:flex': menuState === 'in', 'min-w-[300px]': menuState === 'out' }"
    aria-label="Menu toolbar"
    class="h-[65px]">
    <button
      class="pl-3"
      (click)="toggleMenu()"
      *ngIf="!isExpanded"
      aria-label="Toggle sidenav"
      mat-icon-button
      type="button">
      <mat-icon aria-label="Menu closed icon" class="text-neutral-80">menu</mat-icon>
    </button>
    <div *ngIf="isExpanded" class="flex w-full items-center justify-between">
      <img
        [routerLink]="'home'"
        alt="Logo"
        aria-label="Logo image"
        class="w-52 cursor-pointer"
        src="assets/images/nexusyms.png" />
      <button (click)="toggleMenu()" aria-label="Toggle sidenav button" class="ml-10" mat-icon-button type="button">
        <mat-icon aria-label="Menu opened icon" class="text-neutral-80">menu_open</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <app-header
    [sites]="(sites$ | async) ?? []"
    (headerOptionsToggle)="showMobileHeaderOption($event)"
    (toggleSidebar)="toggleMenu()"
    [menuState]="menuState"
    [navigationItem]="
      selectedItem || {
        label: '',
        routing: '',
        icon: '',
        identifier: '',
        subItems: [],
        canView: this.navigationService.isMenuVisible,
      }
    "
    [isSuperAdmin]="authorizationService.isSuperAdmin$ | async"
    aria-label="App header"
    class="w-full" />
</div>

<mat-sidenav-container
  [ngClass]="
    !environmentType || environmentType === 'prod'
      ? showHeaderOption
        ? 'top-[130px]'
        : 'top-[65px]'
      : showHeaderOption
        ? 'top-[166px]'
        : 'top-[101px]'
  "
  aria-label="Sidenav container"
  class="fixed h-screen w-full">
  <mat-sidenav
    #sidenav
    [@slideInOut]="menuState"
    disableClose
    [fixedInViewport]="true"
    aria-label="Sidenav"
    class="rounded-none"
    [ngClass]="{
      'hidden lg:flex': menuState === 'in',
      'top-[65px]': !environmentType || environmentType === 'prod',
      'top-[101px]': environmentType && environmentType !== 'prod',
    }"
    mode="side"
    opened>
    <mat-nav-list [@slideInOut]="menuState" aria-label="Sidenav list">
      <div [ngClass]="{ 'my-4 ml-3 mr-4': !isExpanded, 'my-2 ml-5 mr-6': isExpanded }">
        @if (authorizationService.isSuperAdmin$ | async) {
          <div
            (click)="navigateToAdminPanel()"
            (keydown)="navigateToAdminPanel()"
            [ngClass]="{ 'active-item font-semibold': selectedItem && selectedItem.routing === 'admin-panel' }"
            aria-label="Admin Panel Section"
            class="nav-item mb-2 flex h-14 cursor-pointer items-center rounded-md px-4 pr-2 text-md"
            tabindex="0">
            <span class="flex items-end text-md">
              <mat-icon aria-label="Admin Panel Icon" class="material-icons-outlined mr-2"
                >admin_panel_settings</mat-icon
              >
              <span *ngIf="isExpanded">{{ 'adminPanel.label' | translate }}</span>
            </span>
          </div>
        }

        <p *ngIf="isExpanded && (clientsMapped$ | async)?.length" class="secondary-label mb-4 ml-1 text-sm uppercase">
          {{ 'navigation.client.label' | translate }}
        </p>

        @if (clientsMapped$ && (clientsMapped$ | async)?.length) {
          <app-dropdown-menu
            [isExpanded]="isExpanded"
            [items]="clientsMapped$ | async"
            aria-label="App dropdown Menu"
            (itemChanged)="clientChanged()" />
        }
      </div>

      <!-- Navigation Items -->
      <div
        *ngFor="let section of navigation$ | async"
        [ngClass]="{
          collapsed: !section.canView(section.identifier),
          'hidden-panel': !section.canView(section.identifier),
        }"
        aria-label="Sidenav section"
        class="mx-4">
        <!-- Section Header -->
        <div
          *ngIf="section.label && section.canView(section.identifier)"
          [ngClass]="{ 'justify-center': !isExpanded, 'ml-1 pr-8': isExpanded }"
          aria-label="Sidenav section header"
          class="secondary-label my-4 flex items-center text-sm uppercase">
          <span
            appFirstLetters
            [text]="section.label | translate"
            [isExpanded]="isExpanded"
            [attr.aria-label]="'Panel title ' + section.label"></span>
        </div>

        <!-- Section Items -->
        <div class="pr-2" *ngFor="let item of section.items">
          <div
            *ngIf="item.canView(item.identifier)"
            [routerLinkActive]="item.subItems?.length ? '' : 'active-item font-semibold'"
            [routerLink]="item.routing"
            [ngClass]="{ 'px-4': isExpanded, 'justify-center': !isExpanded }"
            (click)="onItemSelected(item); item.expanded = !item.expanded"
            tabindex="0"
            class="nav-item mb-1 flex h-14 cursor-pointer items-center rounded-md text-md font-normal"
            [attr.aria-label]="'Sidenav item header' + item.label">
            <mat-icon
              [attr.aria-label]="'Sidenav item icon' + item.label"
              [matMenuTriggerFor]="!isExpanded && item.subItems?.length ? menu : null"
              [ngClass]="{ 'mr-3': isExpanded }"
              class="material-icons-outlined">
              {{ item.icon }}
            </mat-icon>

            <span class="text-md" *ngIf="isExpanded" [attr.aria-label]="'Sidenav item label' + item.label">
              {{ item.label | translate }}
            </span>

            <mat-icon
              *ngIf="item.subItems?.length && isExpanded"
              [ngClass]="{ 'rotate-180': item.expanded }"
              aria-label="Expand arrow"
              class="material-icons-outlined secondary-label ml-auto transition-transform duration-300 ease-in-out">
              keyboard_arrow_down
            </mat-icon>

            <mat-menu #menu="matMenu" [attr.aria-label]="'Subitems menu' + item.label">
              <div
                *ngFor="let subItem of item.subItems; let i = index"
                class="hover:active-item h-12 w-[248px] cursor-pointer">
                <span
                  class="nav-item flex h-12 items-center pl-8 text-md"
                  [tabindex]="i"
                  [routerLink]="subItem.routing"
                  [routerLinkActive]="'active-item font-semibold'"
                  (click)="onItemSelected(subItem)"
                  *ngIf="subItem.canView(subItem.identifier)">
                  {{ subItem.label | translate }}
                </span>
              </div>
            </mat-menu>
          </div>

          <!-- SubItems -->
          <div
            *ngIf="isExpanded"
            [ngClass]="{
              'h-0 overflow-hidden opacity-0 transition-all duration-300 ease-in-out': !item.expanded,
              'h-auto opacity-100 transition-all duration-300 ease-in-out': item.expanded,
            }">
            <div *ngFor="let subItem of item.subItems" class="w-full">
              <button
                [routerLink]="subItem.routing"
                [routerLinkActive]="'font-semibold active-nav-item'"
                (click)="onItemSelected(subItem)"
                *ngIf="subItem.canView(subItem.identifier)"
                class="nav-item my-1 flex h-14 w-full items-center rounded-md text-md">
                <span class="ml-14">
                  {{ subItem.label | translate }}
                </span>
              </button>
            </div>
          </div>
        </div>

        <!-- Divider -->
        <mat-divider
          *ngIf="section.divider && section.canView(section.identifier)"
          [ngClass]="{ 'mx-1': isExpanded, 'ml-1 mr-2': !isExpanded }"
          aria-label="Divider"
          class="text-neutral-60 mt-2" />
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content
    [@slideInOutContent]="{ value: menuState, params: { left: isTabletView ? '0rem' : '5rem' } }"
    class="fixed z-10 m-0 h-[calc(100%-65px)] overflow-auto px-8 py-8"
    [ngClass]="[
      isExpanded ? 'w-[calc(100%-300px)]' : !isTabletView ? 'w-[calc(100%-85px)]' : 'w-full',
      showHeaderOption
        ? environmentType && environmentType === 'prod'
          ? 'max-sm:top-[8rem]'
          : 'max-sm:top-[13rem]'
        : '',
    ]"
    aria-label="Sidenav app main content">
    <!-- Content -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
